export const claimsBillingProviderHistoryColumns = [
  'id',
  'fk_claims_meta_data_id',
  'billing_provider_id_type',
  'billing_provider_id',
  'billing_provider_name',
  'billing_provider_npi',
  'billing_provider_taxonomy_code',
  'billing_provider_addr_street',
  'billing_provider_addr_city',
  'billing_provider_addr_state',
  'billing_provider_addr_zip',
  'billing_provider_contact_id',
  'billing_provider_contact_name',
  'billing_provider_contact_type',
  'billing_provider_contact_phone',
  'billing_provider_pay_to_addr_street',
  'billing_provider_pay_to_addr_city',
  'billing_provider_pay_to_addr_state',
  'billing_provider_pay_to_addr_zip',
  'delimiter',
  'trx_key',
  'meta_lineage_source_system_name',
  'meta_lineage_source_name',
  'meta_lineage_source_offset',
  'meta_load_dt',
  'meta_correlation_id',
  'meta_component',
  'snapshot_id',
  'meta_lineage_content_hash',
];
